import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../context/AuthContext";
import { toast } from "sonner";
import { BellRing, Smartphone } from "lucide-react";
import { pushSupported, currentSubscription, subscribeToPush, unsubscribeFromPush } from "../lib/push";

export default function NotifySettings() {
  const [prefs, setPrefs] = useState({ push: true, email: true });
  const [pushOn, setPushOn] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    axios.get(`${API}/me/notify-prefs`).then(r => setPrefs(r.data)).catch(() => {});
    currentSubscription().then(s => setPushOn(!!s));
  }, []);

  const save = async (next) => { setPrefs(next); await axios.put(`${API}/me/notify-prefs`, next).catch(() => {}); };
  const togglePush = async () => {
    setBusy(true);
    try {
      if (pushOn) { await unsubscribeFromPush(); setPushOn(false); toast.info("Push disattivate su questo dispositivo"); }
      else { await subscribeToPush(); setPushOn(true); await axios.post(`${API}/push/test`); toast.success("Push attive! Ti abbiamo inviato una notifica di prova"); }
    } catch (e) { toast.error(e.message || "Impossibile attivare le push"); } finally { setBusy(false); }
  };

  return (
    <div className="p-3 border-t border-white/5 space-y-2" data-testid="notify-settings">
      <div className="text-[10px] font-mono-rl text-slate-500 tracking-widest flex items-center gap-1"><BellRing className="w-3 h-3" /> RICEVI FUORI DALL'APP</div>
      <button onClick={togglePush} disabled={busy || !pushSupported()} data-testid="push-toggle"
        className={`w-full flex items-center justify-between text-sm px-3 py-2 rounded-lg border ${pushOn ? "border-[#30D158]/50 bg-[#30D158]/10" : "border-white/10"} disabled:opacity-50`}>
        <span className="flex items-center gap-2"><Smartphone className="w-4 h-4" /> Push sul telefono</span>
        <span className="font-mono-rl text-[10px]">{!pushSupported() ? "NON SUPPORTATO" : pushOn ? "ATTIVE" : "ATTIVA"}</span>
      </button>
    </div>
  );
}
